import { useRef, useState } from 'react';
import { ProtocolImageEntry } from '../../../shared/types/protocolImageEntry.ts';
import { PositionSelection } from '../../types/positionSelection.ts';
import { ProtocolDraft } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


export function useImagesState(
    protocol: ProtocolDraft | null,
    positionSelection: PositionSelection | null,
) {
    const [newImages, setNewImages] = useState(new Map<number, Uint8Array>());//Key: positionId
    const imagesToUpload = useRef<ProtocolImageEntry[]>([]);


    const oldImageQueries = trpc.useQueries((t) =>
        protocol?.positions.map((it, index) =>
            t.protocolFiles.getVisualInspectionImage(
                {
                    imageFileName: it.imageFileName ?? '',
                    index
                },
                {
                    enabled: it.imageFileName !== undefined,
                    refetchOnWindowFocus: false,
                }
            )
        ) ?? []
    );


    function getSelectedPositionImage() {
        if (!protocol || !positionSelection) return null;

        const positionId = protocol.positions[positionSelection.positionIdx].id;
        const newImage = newImages.get(positionId);
        if (newImage) {
            return newImage;
        }

        const oldImageQuery = oldImageQueries[positionSelection.positionIdx];
        return oldImageQuery.data ?? null;
    }

    async function handleImageChange(file: File) {
        if (!protocol || !positionSelection) return;
        const positionId = protocol.positions[positionSelection.positionIdx].id;

        const arrayBuffer = new Uint8Array(await file.arrayBuffer());

        setNewImages((prev) => {
            const newState = new Map(prev);
            newState.set(positionId, arrayBuffer);
            return newState;
        });

        imagesToUpload.current.filter(it => it.positionId !== positionId);
        imagesToUpload.current.push({
            positionId,
            imageFile: arrayBuffer,
            fileName: file.name,
        });
    }

    function handleNewImageUploaded(imageEntry: ProtocolImageEntry) {
        const arraysEqual = (a: Uint8Array, b: Uint8Array) => a.length === b.length && a.every((v, i) => v === b[i]);
        imagesToUpload.current.filter(it => !arraysEqual(it.imageFile, imageEntry.imageFile));
    }


    return {
        selectedPositionImage: getSelectedPositionImage(),
        imagesToUpload: imagesToUpload.current,
        handleImageChange,
        handleNewImageUploaded,
    }
}
